import React, { ReactNode, createContext, useCallback, useState } from 'react';
import { RepositoryParams } from '@services/api';
import { BudgetTemplate } from 'interfaces/BudgetTemplate';

type BudgetFilter = {
  budgetTemplateId?: string;
  budgetTemplateName?: string;
  budgetTemplate?: BudgetTemplate;
  costCenterId?: string;
  month?: string;
  type?: string;
  typeDescription?: string;
  department?: string;
  costCenterIncomeId?: string;
  costCenterExpenseId?: string;
  categoryIncomeId?: string;
  categoryExpenseId?: string;
} & RepositoryParams;

export interface FiltersContextType {
  filters: BudgetFilter;
  updateFilters: (filters: BudgetFilter) => void;
  clearFilters: () => void;
}

export const FiltersContext = createContext<FiltersContextType | undefined>(
  undefined
);

interface FiltersProviderProps {
  children: ReactNode;
}

export const FiltersProvider: React.FC<FiltersProviderProps> = ({
  children,
}) => {
  const [filters, setFilters] = useState<BudgetFilter>({
    budgetTemplateId: '',
  });

  const updateFilters = useCallback<FiltersContextType['updateFilters']>(
    (newFilters) => {
      setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
    },
    [setFilters]
  );

  const clearFilters = useCallback<FiltersContextType['clearFilters']>(() => {
    setFilters((prevFilters) => ({
      budgetTemplateId: prevFilters.budgetTemplateId,
      budgetTemplateName: prevFilters.budgetTemplateName,
      budgetTemplate: prevFilters.budgetTemplate,
    }));
  }, [setFilters]);

  return (
    <FiltersContext.Provider value={{ filters, updateFilters, clearFilters }}>
      {children}
    </FiltersContext.Provider>
  );
};
